import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@components/Navbar/Navbar";
import Sidebar from "@components/Sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { EnumUserTypes, userTypes } from "@utils/constants";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import useNotification from "custom-hooks/useNotification";
import { SocketProvider } from "context/SocketProvider";
import useDocumentTitleNotifications from "hooks/useDocumentTitleNotifications";

let socket = null;

const Layout = () => {
  useNotification();
  useDocumentTitleNotifications();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { pathname } = useLocation();
  const { authenticated, logged_in, user } = useSelector((state) => state.auth);
  // Todo
  const isLoggedIn =
    ((logged_in && !!user && !!user?._id) ||
      user?.userType === EnumUserTypes.REFERRAL_AMBASSADOR) &&
    authenticated 
    &&
    !!user?.userName;

  useEffect(() => {
    if (!("Notification" in window)) return; // browser does not support notifications

    if (Notification.permission === "default") {
      Notification.requestPermission().then((permission) => {
        console.log("Notification permission:", permission);
        // permission can be 'granted', 'denied', or 'default'
      });
    }
  }, []);

  return (
    <SocketProvider>
      {/* <div>{(logged_in && !!user && !!user?._id)?.toString()}</div>
      <div>check{isLoggedIn?.toString()}</div> */}
      <div
        className={`flex flex-col items-center w-full no-scrollbar h-screen max-h-screen overflow-hidden relative bg-white  ${
          pathname === "/" ? "bg-cover bg-center" : ""
        }`}
        style={
          pathname === "/"
            ? {
                backgroundImage: `url(${require("../../assets/images/landingBackground.png")})`,
              }
            : {}
        }
      >
        <Navbar />
        {/* Responsive container */}
        <div
          className={`flex flex-col flex-grow w-full ${
            isLoggedIn ? "max-w-[1728px]" : ""
          } no-scrollbar mx-auto h-full`}
        >
          {/* Main content area */}
          <div
            className={`flex flex-grow w-full h-full no-scrollbar max-h-[93vh] ${
              isLoggedIn ? "xl:pl-5 xl:pr-44 px-4" : ""
            }`}
          >
            {/* Sidebar conditionally rendered */}
            {isLoggedIn && <Sidebar />}
            {/* Outlet for page content */}
            <div
              className={`flex flex-1 flex-grow no-scrollbar  ${
                !isLoggedIn
                  ? "flex-col"
                  : "bg-[#F7F8FB] py-5 2xl:px-24 px-4 md:px-8"
              }`}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </SocketProvider>
  );
};

export { socket };
export default Layout;
